'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FinishPage = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactRedux = require('react-redux');

var _navigation = require('program/frontend/actions/navigation');

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _flatIndex = require('program/flat-index');

var _vcenter = require('../components/vcenter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styles = {

  root: {
    position: "absolute",
    top: 64,
    left: 0,
    right: 0,
    bottom: 0,

    textAlign: "center",
    fontFamily: "Roboto, sans-serif",
    fontSize: 16,
    color: "#555"
  },

  header: {
    fontWeight: 300,
    color: "#887",
    marginBottom: 16,
    fontSize: 24
  },

  content: {
    maxWidth: 600,
    margin: 20
  }

};

var FinishPage = _react2['default'].createClass({

  displayName: "FinishPage",

  mixins: [_reactAddonsPureRenderMixin2['default']],

  render: function render() {

    return _react2['default'].createElement(
      'div',
      { style: styles.root },
      _react2['default'].createElement(
        _vcenter.VCenter,
        null,
        _react2['default'].createElement(
          'div',
          { style: styles.content },
          _react2['default'].createElement(
            'div',
            { style: styles.header },
            'Gratulation!'
          ),
          _react2['default'].createElement(
            'p',
            null,
            'Sie haben den Online-Kurs abgeschlossen.'
          ),
          _react2['default'].createElement(
            'p',
            null,
            'Haben Sie noch Fragen? ',
            _react2['default'].createElement(
              'a',
              {
                href: 'https://www.smartfarmer.it/contact',
                target: '_blank'
              },
              'Kontaktieren Sie uns.'
            )
          ),
          _react2['default'].createElement(
            'p',
            null,
            'Empfehlen Sie uns weiter!'
          )
        )
      )
    );
  }
});

exports.FinishPage = FinishPage = (0, _reactRedux.connect)()(FinishPage);

exports.FinishPage = FinishPage;


//////////////////
// WEBPACK FOOTER
// ./program/frontend/finish/index.jsx
// module id = 976
// module chunks = 0